import { render, staticRenderFns } from "./Competencia.vue?vue&type=template&id=daef2406&scoped=true&lang=pug"
import script from "./Competencia.vue?vue&type=script&lang=js"
export * from "./Competencia.vue?vue&type=script&lang=js"
import style0 from "./Competencia.vue?vue&type=style&index=0&id=daef2406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daef2406",
  null
  
)

export default component.exports